import { request } from '@umijs/max';

export type LoginParams = {
	username?: string;
	email?: string;
	password: string;
	autoLogin?: boolean;
	type?: string;
};

export type LoginResult = {
	success: boolean;
	message: string;
	data?: {
		user: {
			id: number;
			name: string;
			email: string;
			avatar?: string;
			roles?: any[];
			permissions?: any[];
		};
		token: string;
	};
};

export type CurrentUser = {
	id: number;
	name: string;
	email: string;
	avatar?: string;
	roles?: any[];
	permissions?: any[];
};

const getApiBaseUrl = (): string => {
	if (typeof window === 'undefined') return '';
	const config = (window as any).__APP_CONFIG__;
	return config?.API_URL || '';
};

const getCsrfToken = (): string | null => {
	if (typeof document === 'undefined') return null;
	const cookies = document.cookie.split('; ');
	const csrfCookie = cookies.find((row) => row.startsWith('XSRF-TOKEN='));
	if (!csrfCookie) return null;
	const token = csrfCookie.split('=')[1];
	return decodeURIComponent(token);
};

// 用户登录
export async function login(params: LoginParams): Promise<LoginResult> {
	const response = await request('/api/login', {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json'
		},
		data: {
			name: params.username,
			password: params.password
		}
	});

	return response;
}

// 用户登出
export async function logout(): Promise<{ success: boolean }> {
	const csrfToken = getCsrfToken();

	const response = await request('/api/logout', {
		method: 'POST',
		credentials: 'include',
		headers: {
			...(csrfToken ? { 'X-XSRF-TOKEN': csrfToken } : {})
		}
	});

	return response;
}

// 获取当前用户信息
export async function currentUser(): Promise<CurrentUser> {
	const csrfToken = getCsrfToken();

	const response = await request<{ success: boolean; message: string; data: CurrentUser }>(
		'/api/currentUser',
		{
			method: 'GET',
			credentials: 'include',
			headers: {
				...(csrfToken ? { 'X-XSRF-TOKEN': csrfToken } : {})
			}
		}
	);

	// 后端返回的是 {success: true, message: "Success", data: {...}} 格式
	// 需要提取 data 字段中的用户信息
	if (response.success && response.data) {
		return response.data;
	}

	throw new Error(response.message || '获取用户信息失败');
}
